import Vue from 'vue'
import Vuex from 'vuex'

import plans from './modules/plans';
import customer from './modules/customer';
import order from './modules/order';
import payment from './modules/payment';

Vue.use(Vuex)


export default new Vuex.Store({
    modules: {
        plans,
        customer,
        order,
        payment
    },
    //plugins: [createPersistedState()]
})
